module.exports = __webpack_public_path__ + "static/media/carteira.b69fc5df.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/carteira.svg
// module id = 483
// module chunks = 0